import LogoImage from "assets/images/logo.png";
import { useState } from "react";
import { classnameDefaults } from "utils/common";
import ComoPagar from "components/Footer/DialogContent/ComoPagar";
import MetodosEnvio from "components/Footer/DialogContent/MetodosEnvio";
import PoliticasDevolucion from "components/Footer/DialogContent/PoliticasDevolucion";
import ComprasComunitarias from "./DialogContent/ComprasComunitarias";
import LogoDev from "assets/images/logo-dev.png";
import QR from "assets/images/qr-big.png";
import PuntoRetiro from "./DialogContent/PuntoRetiro";
import { NavLink } from "react-router-dom";

const Footer = () => {
  const [whatsappPopupOpen, setWhatsappPopupOpen] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [qrOpen, setQrOpen] = useState(false);
  const [dialogContent, setDialogContent] = useState(null);

  const handleDialogOpen = (component) => {
    setDialogContent(component);
    setDialogOpen(true);
  };

  return (
    <>
      <div className={`qr_overlay ${classnameDefaults([qrOpen, "active"])}`}>
        <button onClick={() => setQrOpen(false)}>
          <i className="fas fa-times"></i>
        </button>
        <img src={QR} alt="Escanea y pagá" />
      </div>
      <div
        className={`pop-overlay ${classnameDefaults([dialogOpen, "active"])}`}
      >
        <i className="fas fa-times" onClick={() => setDialogOpen(false)}></i>
        <div className="pop-box">{dialogContent}</div>
      </div>
      <footer>
        <div className="wrapper">
          <div className="cols">
            <div className="col col-1">
              <a href=".">
                <img src={LogoImage} alt="Logotipo Any Natural" />
              </a>
            </div>

            <div className="col col-2">
              <div>
                <a onClick={() => handleDialogOpen(PoliticasDevolucion)}>
                  Devolución / cambios
                </a>
                <a onClick={() => handleDialogOpen(MetodosEnvio)}>
                  Métodos de envío
                </a>
              </div>
            </div>
            <div className="col col-2">
              <div>
                <a onClick={() => handleDialogOpen(ComoPagar)}>Cómo Pagar</a>
                <a onClick={() => handleDialogOpen(ComprasComunitarias)}>
                  Compras comunitarias
                </a>
              </div>
            </div>
            <div className="col col-2">
              <div>
                <a href="https://anynatural.com.ar/blog" target="_blank">
                  El blog de Any!
                </a>
                <a onClick={() => handleDialogOpen(PuntoRetiro)}>
                  Dónde estamos
                </a>
              </div>
            </div>
            <div className="col col-2">
              <div>
                <a
                  href="https://instagram.com/any.natural?igshid=MzRlODBiNWFlZA=="
                  target="_blank"
                >
                  En redes
                </a>
                <NavLink to="tienda/alacena/ts-yerbas-infusiones/yerba-mate-la-buena-x-1kg">
                  Ofertas
                </NavLink>
              </div>
            </div>
          </div>
        </div>
      </footer>
      <div className="under-footer">
        <div className="wrapper">
          <p>Todos los derechos reservados @ {new Date().getFullYear()}</p>
          <a href="https://selenepavlotsky.com/" target="_blank">
            <img src={LogoDev} alt="Logo de Selene Pavlotsky" />
          </a>
        </div>
      </div>
      <button
        className="whatsapp-opener"
        onClick={() => setWhatsappPopupOpen(true)}
      >
        <i className="fab fa-whatsapp"></i>
        <span>Chateá con nosotros!</span>
      </button>

      <div
        className={`whatsapp-container ${classnameDefaults([
          whatsappPopupOpen,
          "active",
        ])}`}
      >
        <div className="top">
          <i
            className="fas fa-times"
            onClick={() => setWhatsappPopupOpen(false)}
          ></i>
          <p>
            ¡Hola! Hacé click en nuestra marca y te responderemos lo antes
            posible
          </p>
        </div>
        <a
          className="bottom"
          href="https://api.whatsapp.com/send?phone=5491127863054"
          target="_blank"
          rel="noreferrer"
        >
          <i className="fab fa-whatsapp"></i>
          <div>
            <span>Estamos para ayudarte</span>
            <p>anynatural.com.ar</p>
          </div>
        </a>
      </div>
    </>
  );
};

export default Footer;
